import cls from 'classnames'
import { isString } from 'lodash'
import React from 'react'

import useTitle from '@/hooks/useTitle.hooks'

import s from './app-header.module.less'

interface AppHeaderProps {
  title?: React.ReactNode
  userHeader?: React.ReactNode
  titleString?: string
  avatar?: React.ReactNode
  actions?: React.ReactNode
  center?: boolean
  isFixed?: boolean
}

export const AppHeader: React.FC<AppHeaderProps> = ({
  title,
  titleString,
  userHeader,
  avatar,
  actions,
  center = false,
  isFixed = false,
  children,
}) => {
  const t = titleString ? titleString : title && isString(title) ? title : ''
  useTitle(t ? t + ' / Tale' : 'Tale', { restoreOnUnmount: true })

  return (
    <div className={s.container} style={isFixed ? { position: 'fixed', top: 0, zIndex: 4, width: '100%' } : undefined}>
      <div className={cls(s.header, { [s.hasChildren]: !!children, [s.isCenter]: center })}>
        {avatar && <div className={s.avatar}>{avatar}</div>}

        {title && <div className={s.title}>{title}</div>}
        {userHeader && <div className={s.userHeader}>{userHeader}</div>}

        {actions && <div className={s.actions}>{actions}</div>}
      </div>
      {children}
    </div>
  )
}
